import { DataGrid, esES, DataGridProps } from '@mui/x-data-grid'
import { useEffect, useState } from 'react'
import { useDrawerStore } from '../../store/drawer'

const CustomDataGrid = (props: DataGridProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { drawerIsOpen } = useDrawerStore()

  useEffect(() => {
    if (isOpen !== drawerIsOpen) {
      setIsOpen(drawerIsOpen)
    }
  }, [drawerIsOpen, isOpen])

  // When isOpen is different to drawerIsOpen we need to re render the table to fit on the full screen
  const useAutoPageSize = props.paginationMode !== 'server'
  
  return isOpen === drawerIsOpen ? <DataGrid
            autoPageSize={useAutoPageSize}
            localeText={
              esES.components.MuiDataGrid.defaultProps.localeText
            }
            disableRowSelectionOnClick={props.disableRowSelectionOnClick ?? true}
            disableColumnMenu
            disableColumnSelector
            {...props}
          /> : null
}

export default CustomDataGrid